import { useMemo } from 'react';
import { useTokens } from '../../shared/theme.jsx';
import InstitutionMark from '../../shared/InstitutionMark.jsx';
import {
  cancelInstitutionAiTurn,
  createInstitutionAiConversation,
  getInstitutionAiConversation,
  listInstitutionAiConversations,
  reattachInstitutionAiTurn,
  streamInstitutionAiMessage,
  submitInstitutionSupportRequest,
} from '../../shared/services/institutions.js';
import AiChatShell, { AiChatSkeleton as InstitutionAiSkeleton } from '../../shared/ai/AiChatShell.jsx';

export { formatChatTime } from '../../shared/ai/AiChatShell.jsx';
export { InstitutionAiSkeleton };

export default function InstitutionAiView({
  institutionName = 'your institution',
  slug,
  logoFileId,
  logoSource,
  autoLogoDomain,
  profile,
  conversationId = null,
  onConversationChange,
}) {
  const t = useTokens();
  const storageKey = useMemo(() => {
    return `cc.institution-ai.history:${slug || institutionName}`;
  }, [institutionName, slug]);

  return (
    <AiChatShell
      storageKey={storageKey}
      modeKey="cc.institution-ai.response-mode"
      profile={profile}
      streamMessage={streamInstitutionAiMessage}
      initialConversationId={conversationId}
      onConversationChange={onConversationChange}
      listConversations={listInstitutionAiConversations}
      createConversation={createInstitutionAiConversation}
      loadConversation={getInstitutionAiConversation}
      reattachTurn={reattachInstitutionAiTurn}
      cancelTurn={cancelInstitutionAiTurn}
      submitSupportRequest={submitInstitutionSupportRequest}
      enableAttachments
      renderIdentity={() => {
        return (
          <>
            <InstitutionMark
              name={institutionName}
              slug={slug}
              logoFileId={logoFileId}
              logoSource={logoSource}
              autoLogoDomain={autoLogoDomain}
              size={56}
            />
            <span className="text-[22px] font-semibold leading-tight" style={{ color: t.heading, fontFamily: t.fonts.body }}>{institutionName}</span>
          </>
        );
      }}
    />
  );
}
